import { forwardRef } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

import {
  SELECT_CONTENT_DEFAULTS,
  SELECT_CONTENT_POSITION_CLASS_MAP,
  type TSelectContentElement,
  type TSelectContentProps,
} from "@/ui/components/form/Select/Select.config";
import { cn } from "@/ui/lib/utils";
import {
  SelectScrollDownButton,
} from "@/ui/components/form/Select/SelectScrollDownButton";
import {
  SelectScrollUpButton,
} from "@/ui/components/form/Select/SelectScrollUpButton";
import { SelectViewport } from "@/ui/components/form/Select/SelectViewport";

export const SelectContent = forwardRef<TSelectContentElement, TSelectContentProps>(
  (
    {
      children,
      className,
      position = SELECT_CONTENT_DEFAULTS.position,
      ...props
    },
    ref,
  ) => (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Content
        data-component="SelectContent"
        ref={ref}
        className={cn(
          "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-sys-sm border border-solid border-component-input-default bg-component-input-focused shadow-md",
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          SELECT_CONTENT_POSITION_CLASS_MAP[position],
          className,
        )}
        position={position}
        {...props}
      >
        <SelectScrollUpButton />
        <SelectViewport position={position}>
          { children }
        </SelectViewport>
        <SelectScrollDownButton />
      </SelectPrimitive.Content>
    </SelectPrimitive.Portal>
  ),
);

SelectContent.displayName = SelectPrimitive.Content.displayName;
